var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.isverificationenabled) ? _c('fieldset', [_c('b-card', [_c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.isverificationenabledMsg))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isverificationenabled) ? _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("AWB Verification (Dim & Wt)")]), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "background-color": "rgb(208, 219, 225)"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("AWB No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBnumber),
      expression: "AWBnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "AWBnumber",
    class: {
      'form-control': true, 'error': _vm.errors.has('AWBnumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB",
      "name": "AWBnumber",
      "id": "AWBnumber"
    },
    domProps: {
      "value": (_vm.AWBnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWBnumber')),
      expression: "errors.has('AWBnumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The AWB field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getAWBVerificationDimWt
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    staticStyle: {
      "font-size": "1.2rem"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "width": "100%"
    },
    style: ((_vm.inputs.IsMeasurementFlag || _vm.isdisable) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": (_vm.inputs.IsMeasurementFlag || _vm.isdisable) ? true : false
    }
  }, [_vm._v("Mark verification completed")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Total boxes: " + _vm._s(_vm.totbx))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Picked physical weight (kg): " + _vm._s(_vm.ppw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Picked volumetric weight (kg): " + _vm._s(_vm.pvw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification status: " + _vm._s(_vm.awbvst))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Verified physical weight (kg): " + _vm._s(_vm.vpw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Verified volumetric weight (kg): " + _vm._s(_vm.vvw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification done by: " + _vm._s(_vm.awbvdby))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    style: (_vm.pwd < 0 ? 'color:red;' : _vm.pwd > 0 ? 'color:green;' : '')
  }, [_vm._v("Physical weight difference (kg): " + _vm._s(_vm.pwd)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("(Verified - Picked)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    style: (_vm.vwd < 0 ? 'color:red;' : _vm.vwd > 0 ? 'color:green;' : '')
  }, [_vm._v("Volumetric weight difference (kg): " + _vm._s(_vm.vwd)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("(Verified - Picked)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification done at: " + _vm._s(_vm.awbvdat))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification Date and Time: " + _vm._s(_vm.awbvdt))])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "0px",
      "margin-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    style: ((_vm.inputs.IsMeasurementFlag || Object.keys(_vm.inputs).length <= 0) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": (_vm.inputs.IsMeasurementFlag || Object.keys(_vm.inputs).length <= 0) ? true : false
    },
    on: {
      "click": _vm.addBox
    }
  }, [_vm._v("Add box")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    style: ((_vm.inputs.IsMeasurementFlag || _vm.remArr.length <= 0) ? 'opacity: 0.8; cursor: not-allowed; width: 14%;' : 'width: 14%;'),
    attrs: {
      "type": "button",
      "disabled": (_vm.inputs.IsMeasurementFlag || _vm.remArr.length <= 0) ? true : false
    },
    on: {
      "click": _vm.removeBoxes
    }
  }, [_vm._v("Remove box(es)")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Select")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Dimensions L B H (in cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Number of boxes")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Physical weight per box (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Total physical weight (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Volumetric weight per box (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Total volumetric weight (kg)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inputs.SKUDetails), function(input, k) {
    return _c('tr', {
      key: k
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.remArr),
        expression: "remArr"
      }],
      staticClass: "form-control",
      style: (_vm.inputs.IsMeasurementFlag ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": _vm.inputs.IsMeasurementFlag
      },
      domProps: {
        "value": k,
        "checked": Array.isArray(_vm.remArr) ? _vm._i(_vm.remArr, k) > -1 : (_vm.remArr)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.remArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = k,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.remArr = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.remArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.remArr = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Length),
        expression: "input.PackageDetails.Dimensions.Length"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("l" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Length)
      },
      on: {
        "change": function($event) {
          return _vm.boxCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Length", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Width),
        expression: "input.PackageDetails.Dimensions.Width"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("b" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Width)
      },
      on: {
        "change": function($event) {
          return _vm.boxCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Width", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Height),
        expression: "input.PackageDetails.Dimensions.Height"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("h" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Height)
      },
      on: {
        "change": function($event) {
          return _vm.boxCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Height", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.NoOfBoxes),
        expression: "input.NoOfBoxes"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("bx" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? true : false,
        "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.NoOfBoxes)
      },
      on: {
        "change": function($event) {
          return _vm.boxCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "NoOfBoxes", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Weight.PhyWeight),
        expression: "input.PackageDetails.Weight.PhyWeight"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("pw" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber) ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Weight.PhyWeight)
      },
      on: {
        "change": function($event) {
          return _vm.phyCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Weight, "PhyWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.totPWeight),
        expression: "input.totPWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("topw" + k)
      },
      domProps: {
        "value": (input.totPWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "totPWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Weight.VolWeight),
        expression: "input.PackageDetails.Weight.VolWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("vw" + k)
      },
      domProps: {
        "value": (input.PackageDetails.Weight.VolWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Weight, "VolWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.totVWeight),
        expression: "input.totVWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("tovpw" + k)
      },
      domProps: {
        "value": (input.totVWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "totVWeight", $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), (Object.keys(_vm.inputs).length <= 0 || _vm.inputs.SKUDetails.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.confmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5c8f962","hasScoped":true}!./src/views/components/AWBVerificationDimWt/AWBVerificationDimWt.component.html
// module id = 1567
// module chunks = 2